import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import DiagnosticOverview from "./sections/DiagnosticOverview";
import ProcessSteps from "./sections/ProcessSteps";
import AboutTheConsultant from "./sections/AboutTheConsultant";
import PrimaryCallToAction from "./sections/PrimaryCallToAction";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <DiagnosticOverview />
      <ProcessSteps />
      <AboutTheConsultant />
      <PrimaryCallToAction />
      <Contact />
      <Footer />
    </div>;
}